export const colors = {
  text: "#1a1a1a",
  textSecondary: "#444",
  textMuted: "#666",
  textFaint: "#999",
  textFaintest: "#bbb",
  border: "#e8e6e1",
  borderLight: "#c8c4be",
  background: "#faf9f7",
  surface: "#fff",
  pillBg: "#f0eeeb",
  markerColor: "#ccc",
} as const;

export const fonts = {
  body: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
  heading: '"Playfair Display", serif',
} as const;

export const breakpoints = {
  mobile: "600px",
} as const;
